import React, { useEffect, useState } from 'react';
import TextField from 'views/common/TextField';
// import { ReactComponent as GoogleIcon } from 'assets/svg/google.svg';
import { Button, Checkbox, Form, Input, Spin } from 'antd';
import { useValidate, ValidateContext } from 'views/context/ValidateContext';
import FieldRegister from 'views/common/FieldRegister';
import useEventCallback from 'hooks/useEventCallback';
import {
  validateEmail,
  validateNewPassEqualConfirmPass,
  validatePassword,
  validateRequired,
} from 'utils/validate';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { cancelRegister, registerRequest } from 'store/reducers/auth';
import { API_STATUS } from 'constants/constants';

const SignUp = ({ onChangeTab, btnRef }) => {
  const [state, setState] = useState({});
  const validate = useValidate('signup');
  const dispatch = useDispatch();
  const {
    register: { status, error },
  } = useSelector((state) => state.auth);
  const location = useLocation();
  const { email, password, fullName } = state;

  const onChangeName = useEventCallback(
    (e) => {
      setState({ ...state, fullName: e.target.value });
    },
    [state]
  );

  const onChangeEmail = useEventCallback(
    (e) => {
      setState({ ...state, email: e.target.value });
    },
    [state]
  );

  const onChangePassword = useEventCallback(
    (e) => {
      setState({ ...state, password: e.target.value });
    },
    [state]
  );

  const onChangeConfirmPassword = useEventCallback(
    (e) => {
      setState({ ...state, confirmPassword: e.target.value });
    },
    [state]
  );

  const onClickButton = () => {
    const error = validate.validateFields();

    if (Object.keys(error || {}).length > 0) {
      return;
    }
    dispatch(
      registerRequest({
        email,
        password,
        fullName,
      })
    );
  };

  const onClickLink = () => {
    onChangeTab();
    if (status === API_STATUS.PROCESSING) {
      dispatch(cancelRegister());
    }
  };

  useEffect(() => {
    if (location.pathname.includes('login')) {
      setState({});
      validate.resetValidate();
    } // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    if (status === API_STATUS.SUCCESS) {
      onClickLink();
    } // eslint-disable-next-line
  }, [status]);

  return (
    <ValidateContext.Provider value={validate}>
      <Form onFinish={onClickButton} className="form-container">
        <div className="form-container__header">
          <div className="title">Sign Up</div>
          <div className="desc">
            Enter your credentials to access your account
          </div>
        </div>
        <div className="form-container__login-other" ref={btnRef}></div>
        <div className="form-container__divide"></div>
        <FieldRegister
          value={state.fullName}
          onChange={onChangeName}
          name="name"
          validate={validateRequired('Name')}
        >
          {({ onBlur, onChange, value, error }) => (
            <TextField
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              helperText={error}
              label="Name"
              placeholder="Enter name"
            />
          )}
        </FieldRegister>
        <FieldRegister
          value={state.email}
          onChange={onChangeEmail}
          name="email"
          validate={[validateRequired('Email'), validateEmail]}
        >
          {({ onBlur, onChange, value, error }) => (
            <TextField
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              helperText={error}
              label="Email address"
              placeholder="Enter email address"
            />
          )}
        </FieldRegister>
        <FieldRegister
          value={state.password}
          onChange={onChangePassword}
          name="password"
          validate={[
            validateRequired('Password'),
            validatePassword,
            validateNewPassEqualConfirmPass,
          ]}
          depend={state.confirmPassword}
        >
          {({ onBlur, onChange, value, error }) => (
            <TextField
              label="Password"
              helperText={error}
              placeholder="Enter password"
              onBlur={onBlur}
              onChange={onChange}
              value={value}
            >
              <Input.Password />
            </TextField>
          )}
        </FieldRegister>
        <FieldRegister
          value={state.confirmPassword}
          onChange={onChangeConfirmPassword}
          name="confirmPassword"
          depend={state.password}
          validate={validateNewPassEqualConfirmPass}
        >
          {({ onBlur, onChange, value, error }) => (
            <TextField
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              helperText={error}
              label="Confirm Password"
              placeholder="Enter confirm password"
            >
              <Input.Password />
            </TextField>
          )}
        </FieldRegister>
        <div className="form-container__term">
          <Checkbox />
          <span className="text">I agree to the Term & Privacy</span>
        </div>
        <div className="form-container__process">
          <div>{status === API_STATUS.PROCESSING && <Spin />}</div>
          {error && <div className="error">{error}</div>}
        </div>
        <div className="form-container__button-action">
          <Button htmlType="submit">Sign up</Button>
        </div>
        <div className="form-container__more-info">
          <span className="text">Already have an account?</span>
          <span className="link" onClick={onClickLink}>
            Login here
          </span>
        </div>
      </Form>
    </ValidateContext.Provider>
  );
};

export default React.forwardRef((props, ref) => (
  <SignUp btnRef={ref} {...props} />
));
